import {
  NgModule,
  Injectable,
  ModuleWithProviders,
  inject
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../services/common.service';
import { EventType } from '../models/event-type.model';

const _window = (): Window => window;

@Injectable()
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}

@NgModule({
  providers: [WindowRef]
})
export class BackButtonDisableModule {
  private router = inject(Router);
  private windowRef = inject(WindowRef);
  private readonly commonservice = inject(CommonService);

  private window: Window;
  private readonly isMobileViewNewCheckout: boolean;
  private currentRouteLocation: string = '';

  constructor() {
    this.window = this.windowRef.nativeWindow;
    this.isMobileViewNewCheckout = this.window.innerWidth <= 767;
    if (this.isMobileViewNewCheckout) {
      this.disableBackButton();
      this.addPopStateEventListener();
    }
  }

  static forRoot(): ModuleWithProviders<BackButtonDisableModule> {
    return {
      ngModule: BackButtonDisableModule
    };
  }

  private addPopStateEventListener(): void {
    this.window.addEventListener('popstate', (event: PopStateEvent) => {
      if (event && (event.currentTarget as Window).location.href) {
        const currentLocation = (event.currentTarget as Window).location.href;
        if (
          !this.commonservice.isOpenSuperbFromAttendeeAPP &&
          currentLocation.includes(this.currentRouteLocation)
        ) {
          this.commonservice.isUserNavigateThroughBrouserBackButton = true;
          this.commonservice.onBrowserNavigationUpdateState$.next(
            currentLocation
          );
        }
      }
    });
  }

  private disableBackButton(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRouteLocation = event.urlAfterRedirects;
        // After checking need to remove this condition for the Rs
        if (
          !(
            this.currentRouteLocation.includes('checkout') &&
            this.commonservice.eventType === EventType.ReservedSeatMode
          )
        ) {
          this.window.history.pushState(null, null, null);
        }
      }
    });
  }
}
